import React from 'react';

const copyrightText = {
    en: 'Copyright © 2022 Multi-Health Systems, Inc. (MHS, Inc.). All rights reserved.',
    fr: 'Copyright © 2022 Multi-Health Systems, Inc. (MHS, Inc.). Tous droits réservés.',
    es: 'Copyright © 2022 Multi-Health Systems, Inc. (MHS, Inc.). Todos los derechos reservados.'
}

const Copyright = ({children, lang}) => (
    <div className="copyright">{children ? children : copyrightText[lang]}</div>
)

export default Copyright;